import NavigationController from './navigation_controller'

export default class ScrollToController extends NavigationController {
  static targets = [
    'item'
  ]

  modifierChanged ({ detail: { id, isValid, isReachedLimit } }) {
    this.updatePageById(id, { isValid, isCompleted: isReachedLimit })
    this.scrollToNextPage(id)
  }

  scrollToNextPage (pageId) {
    const page = this.findPageById(pageId)

    if (page.isCompleted) {
      this.updateAllPages({ isCurrent: false })
      const nextPosition = page.position + 1
      const nextPage = this.findPageByPosition(nextPosition)
      if (nextPage !== undefined) {
        this.updatePageById(nextPage.id, { isCurrent: true })
      }
    }
  }

  dispatchPageUpdated (page) {
    this.itemTargets.forEach(itemTarget => {
      this.dispatch('pageUpdated', { target: itemTarget, detail: page })
    })
  }
}
